import { useIgConnectOAuth } from '../../hooks';

import { AddButton } from '@/components';
import config from '@/config';
import { Departments } from '@/types';

type Props = { isLoading: boolean; department: Departments };

export const AddInstConnectButton = ({ isLoading, department }: Props) => {
  const { open, isLoading: isConnecting } = useIgConnectOAuth({ department });

  if (!config.isInstagramConnect) {
    return null;
  }

  return (
    <AddButton isLoading={isLoading || isConnecting} onClick={open} text="INSTAGRAM CONNECT" />
  );
};
